import ApiService from './api.service';

class ActivityTypeService {
  async list() {
    try {
      const response = await ApiService.get('/activity-type');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(data) {
    try {
      const response = await ApiService.post('/activity-type/add', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const response = await ApiService.put('/activity-type/update', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(id) {
    try {
      const response = await ApiService.delete('/activity-type/delete', { id });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new ActivityTypeService(); 